import { useQuery } from '@tanstack/react-query';
import { eventApi } from '../api/eventApi';
import { QUERY_KEYS } from '@/shared/config/constants';

export const useActiveEvent = () => {
  const query = useQuery({
    queryKey: QUERY_KEYS.EVENT_ACTIVE,
    queryFn: eventApi.getActive,
    staleTime: 60 * 60 * 1000,
  });
  return {
    event: query.data?.event ?? null,
    eventoId: query.data?.event?.id ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
